/**
 * OverlayRoot - ensures a single #overlays portal root exists
 */
export function ensureOverlayRoot() {
  let root = document.getElementById('overlays');
  if (!root) {
    root = document.createElement('div');
    root.id = 'overlays';
    document.body.appendChild(root);
  }
  // Inject base styles once
  if (!document.getElementById('uk-overlay-styles')) {
    const style = document.createElement('style');
    style.id = 'uk-overlay-styles';
    style.textContent = `
/* Basic overlay and modal styles for UI kit (inlined for PROD) */
#overlays { position: fixed; inset: 0; pointer-events: none; z-index: 2147483600; }
.uk-overlay { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,.45); pointer-events: all; }
.uk-modal { background: #fff; color: #1a1a1a; min-width: 360px; max-width: 880px; max-height: 80vh; border-radius: 10px; box-shadow: 0 14px 40px rgba(0,0,0,.25); display: flex; flex-direction: column; }
.uk-modal-header { display:flex; align-items:center; justify-content:space-between; padding:12px 16px; border-bottom:1px solid #eee; }
.uk-modal-title { font-size: 16px; font-weight: 600; margin: 0; }
.uk-modal-close { background:none; border:none; font-size:20px; cursor:pointer; line-height:1; padding:4px 8px; }
.uk-modal-body { padding:16px; overflow:auto; }
.uk-modal-footer { padding:10px 16px; display:flex; justify-content:flex-end; gap:8px; border-top:1px solid #eee; }
.uk-btn { padding:8px 12px; border-radius:8px; border:1px solid #ddd; cursor:pointer; }
.uk-btn-primary { background:#005EB8; border-color:#005EB8; color:#fff; }
.uk-btn-secondary { background:#fff; color:#1a1a1a; }
/* "sheet" presentation: top-aligned modal with generous viewport height */
.uk-modal.sheet { max-height: calc(100vh - 140px); margin-top: 70px; align-self: flex-start; }
`;
    document.head.appendChild(style);
  }
  return root;
}

export default ensureOverlayRoot;
